import { render, staticRenderFns } from "./view-voucher-button.vue?vue&type=template&id=dd1950a4"
import script from "./view-voucher-button.vue?vue&type=script&lang=js"
export * from "./view-voucher-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports